









import Moment from "moment";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IAiPhraseRecord, IAiPhraseRecordInformation, } from "../../../../../domain/externalSystem";

@Component
export default class AiPhraseRecordViewer extends Mixins() {
  @Prop()
  records: IAiPhraseRecordInformation[];

  toSupplement(source: IAiPhraseRecord): string {
    return [
      source.source ? source.source : "",
      source.at ? "記載日:"  + this.toDateString(source.at) : "",
      (source.author && source.author.name ? "記載者:" + source.author.name + (source.author.role ? "(" + source.author.role + ")" : "") : ""),
      source.department ? source.department : "",
    ].filter(s => !!s).join(" ");
  }

  toDateString(source?: Date): string {
    return source
      ? Moment(source).format("YYYY/MM/DD")
      : undefined;
  }

  toRecordClass(source: IAiPhraseRecordInformation): string {
    return source.isImportant ? "important" : undefined;
  }
}
